export const API_ENDPOINTS = {
  LOGIN_ENDPOINT: "/auth/login/",
  REFRESH_TOKEN_ENDPOINT: "/auth/token/refresh/",
  FORGOT_PASSWORD_ENDPOINT: "/auth/password/",
  DISABLE_MFA_ENDPOINT: "/auth/disable-mfa/",
};
